module.exports = __webpack_public_path__ + "static/media/color-old.40445555.jpeg";